export function hasKey(object, key) {
  return key in object;
}
